export const sortTagsAsc = tags => {
  if (!tags?.length) return []

  return [...tags].sort((a, b) => a.localeCompare(b))
}

export const getTagsDiff = (prev, next) => {
  return {
    added: next.filter(tag => !prev.includes(tag)),
    removed: prev.find(tag => !next.includes(tag)),
  }
}
